export type MenuProblemKind = 'likely_system' | 'individual_source' | 'needs_verification' | 'updating'

export const MENU_PROBLEM_ORDER: readonly MenuProblemKind[] = [
  'likely_system',
  'needs_verification',
  'individual_source',
  'updating',
]

export const MENU_PROBLEM_LABELS: Record<MenuProblemKind, string> = {
  likely_system: 'Likely CannaSpy system issue',
  individual_source: 'Individual menu issue',
  needs_verification: 'Needs source verification',
  updating: 'Update in progress',
}

export const MENU_PROBLEM_DESCRIPTIONS: Record<MenuProblemKind, string> = {
  likely_system: 'Several menus are failing in the same pattern. Check the collector or adapter first.',
  individual_source: 'This menu is failing by itself. Verify its exact public listing and provider.',
  needs_verification: 'No verified public menu is attached yet.',
  updating: 'A refresh is already running. Wait for it to finish before intervening.',
}

export function menuProblemTone(kind: MenuProblemKind): 'danger' | 'warning' | 'neutral' | 'positive' {
  if (kind === 'likely_system') return 'danger'
  if (kind === 'updating') return 'positive'
  if (kind === 'needs_verification') return 'warning'
  return 'neutral'
}

export function safePublicMenuLink(value: string | null): string | null {
  if (!value) return null
  try {
    const url = new URL(value)
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.toString() : null
  } catch {
    return null
  }
}
